import moment from 'moment';
import { Moment } from 'moment';
import { StringHelper } from './string.helper';

export class DateRange {
    public readonly validFrom: Moment;
    public readonly validTo: Moment;

    constructor(validFrom: Moment, validTo: Moment) {
        this.validFrom = validFrom;
        this.validTo = validTo;
    }
}

export class MomentHelper {
    public static minMoment(): Moment {
        return moment().year(1).month(0).date(1);
    }

    public static maxMoment(): Moment {
        return moment().year(9999).month(11).date(31);
    }

    public static isDefault(value: Moment): boolean {
        if (value) {
            return value.year() === 1
                && value.month() === 0 // months are zero indexed
                && value.date() === 1;
        }

        return false;
    }

    public static convertToString(momentAsAny: any): string {
        if (moment.isMoment(momentAsAny)) {
            return moment(momentAsAny).format('YYYY-MM-DD');
        }

        return StringHelper.empty;
    }

    public static convertToMoment(
        dateAsAny: any,
        fallback: Moment = MomentHelper.maxMoment()
    ): Moment {
        if (moment.isMoment(dateAsAny)) {
            return dateAsAny as Moment;
        }

        if (StringHelper.isString(dateAsAny)) {
            const dateAsString = dateAsAny as string;

            if (!StringHelper.isNullOrWhitespace(dateAsString)) {
                const result = moment.parseZone(dateAsString);
    
                if (!MomentHelper.isDefault(result)) {
                    return result;
                }
            }
        }

        return fallback;
    }

    public static parseAsMoment(
        dateAsAny: any,
        format: string = 'DD.MM.YYYY.',
        fallback: Moment = MomentHelper.maxMoment()
    ): Moment {
        if (StringHelper.isString(dateAsAny)) {
            const dateAsString = dateAsAny as string;

            if (!StringHelper.isNullOrWhitespace(dateAsString)) {
                return moment(dateAsString, format);
            }
        }

        return fallback;
    }

    public static formatFullDateComponent(dateAsString: string): string {
        if (!StringHelper.isNullOrWhitespace(dateAsString)) {
            return moment.parseZone(dateAsString).format('DD.MM.YYYY.');
        }

        return StringHelper.empty;
    }

    public static formatPartialTimeComponent(dateAsString: string): string {
        if (!StringHelper.isNullOrWhitespace(dateAsString)) {
            const date = moment(dateAsString, 'HH:mm:ss');

            return date.format('HH:mm');
        }

        return StringHelper.empty;
    }

    public static formatFullTimeComponent(dateAsString: string): string {
        if (!StringHelper.isNullOrWhitespace(dateAsString)) {
            const date = moment(dateAsString, 'HH:mm');

            date.second(59);

            return date.format('HH:mm:ss');
        }

        return StringHelper.empty;
    }

    public static areDateRangesOverlapping(first: DateRange, second: DateRange): boolean {
        const firstValidFrom = first.validFrom;
        const firstValidTo = first.validTo ?? MomentHelper.maxMoment();
        const secondValidFrom = second.validFrom;
        const secondValidTo = second.validTo ?? MomentHelper.maxMoment();

        return firstValidFrom.isSameOrBefore(secondValidTo)
            && secondValidFrom.isSameOrBefore(firstValidTo);
    }
}